// 内容管理 =》 资讯管理
export default {
  BASE_URL: 'content/cmsNews',
  api: [
    {
      name: 'categories',
      method: 'GET',
      desc: '获取资讯分类',
      path: '/catalogList'
    },
    {
      name: 'addCategory',
      method: 'POST',
      desc: '新增资讯分类',
      path: '/addCatalog'
    },
    {
      name: 'updateCategory',
      method: 'POST',
      desc: '编辑资讯分类',
      path: '/editCatalog'
    },
    {
      name: 'deleteCategory',
      method: 'GET',
      desc: '删除资讯分类',
      path: '/delCatalog',
      append: true
    },
    {
      name: 'updateCategoryStatus',
      method: 'POST',
      desc: '启用/停用资讯分类',
      path: '/upCataStatus'
    },
    {
      name: 'list',
      method: 'GET',
      desc: '获取资讯列表',
      path: '/newsList',
      params: {
        newsTitle: '',
        newsCataId: ''
      }
    },
    {
      name: 'add',
      method: 'POST',
      desc: '新增资讯信息',
      path: '/addDetail'
    },
    {
      name: 'sortNum',
      method: 'GET',
      desc: '获取推荐排序号',
      path: '/getSortNum',
      append: true
    },
    {
      name: 'edit',
      method: 'POST',
      desc: '编辑资讯信息',
      path: '/editManage'
    },
    {
      name: 'info',
      method: 'GET',
      desc: '查看资讯信息',
      path: '/newsInfo',
      append: true
    },
    {
      name: 'delete',
      method: 'GET',
      desc: '删除资讯信息',
      path: '/delDetail',
      append: true
    },
    {
      name: 'updateStatus',
      method: 'POST',
      desc: '更新是否发布',
      path: '/upRelease'
    },
    {
      name: 'updateRecommend',
      method: 'POST',
      desc: '更新是否推荐',
      path: '/upRecommend'
    },
    {
      name: 'updateNums',
      method: 'POST',
      desc: '更新资讯阅读或者转发数量',
      path: '/upNum'
    },
    {
      name: 'updateSorts',
      method: 'POST',
      desc: '更新资讯分类顺序',
      path: '/upCataSort'
    },
    {
      name: 'checkCateName',
      method: 'POST',
      desc: '校验资讯类型名称',
      path: 'checkCataName'
    },
    {
      name: 'getCategoryById',
      method: 'POST',
      desc: '根据分类id获取资讯分类',
      path: 'cataInfo'
    },
    {
      name: 'checkNewsName',
      method: 'POST',
      desc: '检查资讯标题是否重复',
      path: '/checkNewsName'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/cms/news.js